import { Create } from "react-admin";
import { QuizAssessmentQuestionBankForm } from "./component/quiz-assessment-question-bank.form";

export function QuizAssessmentQuestionBankCreate(props) {
    return (
        <>
            <Create {...props}>
                <QuizAssessmentQuestionBankForm />
            </Create>
        </>
    )
}
